import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf, ArrowUpRight } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && user) navigate("/dashboard", { replace: true });
    }, [user, loading, navigate]);

    const handleLogin = () => {
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl
        )}`;
    };

    return (
        <div
            className="min-h-screen w-full flex items-center justify-center px-6 relative overflow-hidden"
            style={{
                backgroundImage:
                    "url('https://images.unsplash.com/photo-1772058526152-b54fe36f23de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHNvZnQlMjBncmVlbiUyMG5hdHVyZSUyMHRleHR1cmV8ZW58MHx8fHwxNzc3NjUzMDYxfDA&ixlib=rb-4.1.0&q=85')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="absolute inset-0 bg-[#0b1a12]/25 backdrop-blur-[2px]" />

            <div className="relative z-10 w-full max-w-md">
                <div
                    className="rounded-[2rem] p-8 md:p-10 border border-white/30 shadow-[0_24px_80px_rgba(0,0,0,0.2)] nl-fade-up"
                    style={{
                        background: "rgba(249,249,246,0.88)",
                        backdropFilter: "blur(24px)",
                    }}
                >
                    <div className="flex items-center gap-2 mb-10">
                        <Leaf className="w-5 h-5" style={{ color: "#3B824E" }} />
                        <span className="font-eyebrow text-[#4A5A4E]">NutriLens</span>
                    </div>

                    <h1
                        className="font-serif-editorial text-4xl sm:text-5xl leading-[1.05] tracking-tight"
                        style={{ color: "#1A3626" }}
                    >
                        Groceries that
                        <br />
                        <em className="italic font-normal">fit your body.</em>
                    </h1>

                    <p className="mt-5 text-[#4A5A4E] leading-relaxed text-[15px]">
                        Snap any item. Our AI reads the label and scores it against
                        your own health, not generic rules.
                    </p>

                    <button
                        onClick={handleLogin}
                        data-testid="google-login-btn"
                        className="group mt-10 nl-btn-primary w-full justify-center"
                    >
                        <svg className="w-5 h-5" viewBox="0 0 24 24">
                            <path
                                fill="#fff"
                                d="M21.35 11.1H12v2.96h5.38c-.23 1.44-1.7 4.24-5.38 4.24-3.23 0-5.87-2.68-5.87-5.98s2.64-5.98 5.87-5.98c1.84 0 3.07.78 3.78 1.45l2.58-2.48C16.8 3.84 14.62 2.9 12 2.9 6.98 2.9 2.9 6.98 2.9 12s4.08 9.1 9.1 9.1c5.25 0 8.73-3.69 8.73-8.88 0-.6-.06-1.04-.14-1.52z"
                            />
                        </svg>
                        <span>Continue with Google</span>
                        <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </button>

                    <p className="mt-5 text-xs text-[#8BA092] text-center">
                        Secure sign-in · Your health data stays yours
                    </p>
                </div>

                <div className="mt-6 flex items-center justify-center gap-6 text-white/80 text-xs tracking-widest uppercase font-medium">
                    <span>Scan</span>
                    <span className="opacity-50">·</span>
                    <span>Score</span>
                    <span className="opacity-50">·</span>
                    <span>Shop smart</span>
                </div>
            </div>
        </div>
    );
}
